import { FE_MIGRATE_USER_STORE_250222 } from "@faire/retailer-settings/FE_MIGRATE_USER_STORE_250222";
import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { useEffect } from "react";

export const useSettingAndAssignMigrateUserStore = () => {
  const assignSetting = useAssignSetting(FE_MIGRATE_USER_STORE_250222);
  useEffect(() => {
    assignSetting();
  }, [assignSetting]);

  return useSetting(FE_MIGRATE_USER_STORE_250222);
};
